import * as Yup from 'yup';
import {
  WorkerAlreadyExistsError,
  CompanyAlreadyExistsError,
  InvalidTwoFACodeError,
} from 'constants/ErrorMessages';

function workerAlreadyExistsTest(this: Yup.AnySchema) {
  return this.test(
    'workerAlreadyExistsTest',
    WorkerAlreadyExistsError,
    function () {
      return this.parent._formError !== WorkerAlreadyExistsError;
    },
  );
}

function companyAlreadyExistsTest(this: Yup.AnySchema) {
  return this.test(
    'companyAlreadyExistsTest',
    CompanyAlreadyExistsError,
    function () {
      return this.parent._formError !== CompanyAlreadyExistsError;
    },
  );
}
function twoFACodeIsInvalidCheck(this: Yup.AnySchema) {
  return this.test(
    'twoFACodeIsInvalidCheck',
    InvalidTwoFACodeError,
    function () {
      return this.parent._formError !== InvalidTwoFACodeError;
    },
  );
}

Yup.addMethod(Yup.string, 'workerDuplicateCheck', workerAlreadyExistsTest);
Yup.addMethod(Yup.number, 'workerDuplicateCheck', workerAlreadyExistsTest);
Yup.addMethod(Yup.string, 'companyDuplicateCheck', companyAlreadyExistsTest);
Yup.addMethod(Yup.string, 'twoFACodeIsInvalidCheck', twoFACodeIsInvalidCheck);
